<template>
  <NuxtLayout>
    <NuxtLoadingIndicator color="repeating-linear-gradient(to right,#f5c542 0%,#f3ba1f 50%,#ffba00 100%)" />
    <NuxtPage />
  </NuxtLayout>
</template>
<script lang="ts" setup>
const route = useRoute()
if (!route.path.includes('/manage/healthz')) {
  const { config } = storeToRefs(useStore())
  const { fetchConfig, updateSEO } = useStore()
  await fetchConfig() // 请求公共配置信息
  // 重定向到默认语言
  const redirectLang = () => {
    if (config.value.region_lang && config.value.region_lang !== route.params.lang) {
      if (route.params.lang === '{lang}') {
        navigateTo(`${decodeURIComponent(route.path).replace('{lang}', config.value.region_lang)}`)
      } else {
        navigateTo(`/${config.value.region_lang}/`)
      }
    }
  }
  redirectLang()
  // COMMON SEO CONFIG
  updateSEO() // default seo config
}

// 预初始化 markdown 插件（在浏览器空闲时加载，不阻塞主进程）
onMounted(() => {
  const { $markdown } = useNuxtApp()

  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      $markdown.init().catch((error) => {
        console.warn('Markdown pre-initialization failed:', error)
      })
    })
  } else {
    // 降级方案：延迟 1 秒初始化
    setTimeout(() => {
      $markdown.init().catch((error) => {
        console.warn('Markdown pre-initialization failed:', error)
      })
    }, 1000)
  }
})
</script>
<style lang="scss">
.page-enter-active,
.page-leave-active {
  transition: all 0.2s ease;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  //filter: blur(0.5rem);
}
</style>
